<template>
  <vx-card class="mb-base"
           :title="studentEnrollDetail.subject.code"
           :subtitle="studentEnrollDetail.subject.nameLocal"
           title-color="primary"
           subtitle-color="warning"
  >
    <template slot="actions">
      <div class="flex justify-end mb-4">
        <vs-chip transparent color="primary" class="pr-0">
          <span>{{$t('class-overview.semester')}}</span>
          <vs-chip class="bg-primary ml-2 mb-0 text-white font-semibold">
            {{studentEnrollDetail.studentEnroll.periodCode}}
          </vs-chip>
        </vs-chip>

        <vs-chip transparent color="primary" class="pr-0">
          <span>{{$t('class-overview.section')}}</span>
          <vs-chip class="bg-primary ml-2 mb-0 text-white font-semibold">
            {{ studentEnrollDetail.classSection.sectionNo }}
          </vs-chip>
        </vs-chip>

        <vs-chip transparent color="primary" class="pr-0">
          <span>{{$t('class-overview.span')}}</span>
          <vs-chip class="bg-primary ml-2 mb-0 text-white font-semibold">
            {{ studentEnrollDetail.classSection.learnSpanNo }}
          </vs-chip>
        </vs-chip>
      </div>
    </template>

    <p>{{ studentEnrollDetail.subject.description }}</p>
  </vx-card>
</template>

<script>
  export default {
    name: "SubjectOverview",
    props: ['studentEnrollDetail']
  }
</script>

<style scoped>

</style>
